import { Row, Col, Button } from "react-bootstrap";

const ChartList = ({ sensorList, onChange }: any) => {
    const sensors: any = [...(sensorList || [])];

    const removeSensor = (sensor: any) => {
        const newSensors = sensors.filter(
            (item: any) => item.device_id !== sensor.device_id
        );
        if (typeof onChange === "function") {
            onChange(newSensors);
        }
    };

    return (
        <Row className="cstm-table heatmap-sensor-table mt-4">
            <Col sm={12}>
                {sensors?.length ? (
                    <div className="table-head">
                        <Row className="no-checkbox">
                            <Col xs={{ span: 3 }}>Sensor</Col>
                            <Col xs={{ span: 3 }}>Type</Col>
                            <Col xs={{ span: 3 }}>Gateway</Col>
                            <Col xs={{ span: 2 }}>UUID</Col>
                            <Col xs={{ span: 1 }}> </Col>
                        </Row>
                    </div>
                ) : (
                    ""
                )}

                {sensors.map((sensor: any) => (
                    <div className="table-row" key={sensor.ldsu_uuid}>
                        <Row className="no-checkbox">
                            <Col xs={{ span: 3 }}>{sensor.device_name}</Col>
                            <Col xs={{ span: 3 }}>{sensor.sensor_type}</Col>
                            <Col md={{ span: 3 }}>{sensor.gatewayName}</Col>
                            <Col md={{ span: 2 }}>{sensor.ldsu_uuid}</Col>
                            <Col md={{ span: 1 }} className="text-right">
                                <Button
                                    variant="link"
                                    onClick={() => removeSensor(sensor)}
                                    className="p-0 text-decoration-none"
                                >
                                    <i className="material-icons close-icon d-flex">
                                        close
                                    </i>
                                </Button>
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </Row>
    );
};

export default ChartList;
